import { Injectable } from '@angular/core';

import { STRATEGICAL_CLASSES_INDEXERS } from './../../constants/fixedincome/strategical-classes-indexers.constants';
import { IStrategicalClassesIndexers } from './../../interfaces/fixedincome/strategical-classes-indexers.interface';
import { ITreasuryPosition } from './../../interfaces/fixedincome/treasury-position.interface';
import { ITreasuryPositionsResponse } from './../../interfaces/fixedincome/treasury-positions-response.interface';

@Injectable({ providedIn: 'root' })
export class MyInvestmentsService {

    public strategicalClassesMap(investments: any[]) {

        const strategicalClasses: IStrategicalClassesIndexers = {
            posfixed: [],
            linkedToInflation: [],
            prefixed: [],
            none: []
        };

        investments.forEach((el) => {
            const classByIndexer = this.getClassesByIndexer(el.indexer);
            strategicalClasses[classByIndexer].push(el);
        });

        return this.setOrderPaperAscOperationDateDesk(strategicalClasses);
    }

    public mergePrivateAndTreasuryPositions(
        privatePositions: any[],
        treasuryResponse: ITreasuryPositionsResponse,
        userId?: number,
    ): IStrategicalClassesIndexers {
        return this.strategicalClassesMap([
            ...privatePositions,
            ...this.mapTreasuryPositions(treasuryResponse.positions || [], userId),
        ]);
    }

    private mapTreasuryPositions(positions: ITreasuryPosition[], userId?: number): any[] {
        return positions.map((position) => this.mapTreasuryAvailablePosition(position, userId));
    }

    private mapTreasuryAvailablePosition(position: ITreasuryPosition, userId?: number): any {
        return {
            ...position,
            // o RescueGuard exige userId no produto selecionado para liberar a rota /resgate
            userId,
            bondOperationStatus: 4,
            currentQuantity: position.quantity,
            currentValue: position.value,
            currentValueCurve: position.availableRedeemValue,
            incomeTaxValue: position.irValue,
            issuerName: 'Secretaria do Tesouro Nacional',
            paperType: 1,
            isTreasuryPosition: true,
            pendingAcquireQuantity: 0,
            pendingAcquireValue: 0,
            pendingRedeemQuantity: 0,
            pendingRedeemValue: 0,
            scheduleAcquireQuantity: 0,
            scheduleAcquireValue: 0,
            scheduleRedeemQuantity: 0,
            scheduleRedeemValue: 0,
            blockedQuantity: 0,
            blockedValue: 0,
            unitPriceCurve: position.unitPrice,
        };
    }

    private getClassesByIndexer(indexer: string) {
        const indexerDefault = 'none';

        if (!indexer)
            return indexerDefault;

        return STRATEGICAL_CLASSES_INDEXERS[indexer.toUpperCase()] || indexerDefault;
    }

    private setOrderPaperAscOperationDateDesk(strategicalClasses: IStrategicalClassesIndexers) {

        Object.keys(strategicalClasses).map(key => strategicalClasses[key]
            .sort((a, b) => a.paperType > b.paperType || a.operationDate < b.operationDate ? 1 : -1))

        return strategicalClasses;
    }

}
